import { DeparturePriceResponse } from "@/models/api/DeparturePriceResponse";
import { GetPricedDeparturesRequest } from "@/models/api/GetPricedDeparturesRequest";
import { DeparturePrice } from "@/models/www/DeparturePrice";
import baseApi from "./api.service";

const departureService = {
	searchDepartures(departures: GetPricedDeparturesRequest): Promise<DeparturePrice[]> {
		return new Promise((resolve, reject) => {
			baseApi.post<DeparturePriceResponse[]>("departures/search", departures)
				.then(resp => resolve(resp.map(d => new DeparturePrice(d))))
				.catch(err => reject(err))
		})
	}
}

export default departureService;